import { render, staticRenderFns } from "./customer-dashboard.vue?vue&type=template&id=6b83ddf8&"
import script from "./customer-dashboard.vue?vue&type=script&lang=js&"
export * from "./customer-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports